<template>
  <div class="export-ready">
    <sp-alert type="success" role="status" class="export-ready__banner">
      <span class="export-ready__banner-content">
        <sp-icon name="check-color"></sp-icon>
        <span class="export-ready__banner-title">{{ t("complete_title") }}</span>
      </span>
    </sp-alert>

    <sp-alert
      v-if="searchChanged"
      type="info"
      :text="t('stale_search_notice')"
      icon
      :data-testid="TestId.directoryPdf.staleNotice"
    ></sp-alert>

    <sp-button
      tag="a"
      :href="downloadUrl"
      download="provider-directory.pdf"
      color="primary"
      prepend-icon="download"
      block
      class="export-ready__download"
      :data-testid="TestId.directoryPdf.download"
    >
      {{ t("download_label") }}
    </sp-button>

    <ExportEmailForm />
  </div>
</template>

<script setup>
import { TestId } from "#/test-ids";
import { t } from "#ce/apps/SpDirectoryPdfExport/i18n";
import { useDirectoryPdfExportStore } from "#ce/apps/SpDirectoryPdfExport/store/export";
import ExportEmailForm from "./ExportEmailForm.ce.vue";

const { downloadUrl, searchChanged } = useDirectoryPdfExportStore();
</script>

<style lang="scss" scoped>
.export-ready {
  display: grid;
  gap: var(--sp-ref-scale-24);
  color: var(--sp-sys-color-on-surface);
  text-align: start;

  &__download {
    --sp-comp-button-size: var(--sp-ref-scale-56);
    --sp-comp-button-compact-height: var(--sp-ref-scale-56);
  }

  &__banner {
    --sp-comp-alert-padding: var(--sp-ref-scale-20);
  }

  &__banner-content {
    display: grid;
    justify-items: center;
    gap: var(--sp-ref-scale-4);
    width: 100%;
    padding-block: var(--sp-ref-scale-4);
    text-align: center;
  }

  &__banner-title {
    font: var(--sp-sys-typescale-h5-short);
  }
}
</style>
